<form #formElement *ngIf="form" [formGroup]="form" #formInstance="ngForm" (ngSubmit)="submitted.emit(form.getRawValue())">
  <div class="form" [ngClass]="{ 'form--show-valid': showValidFields, 'form--submitted': this.formState && this.formState.submitted }">
    <div>
      <ng-container *ngFor="let section of controls">
        <div class="form-section {{ section.additionalClass }}" [ngClass]="{ 'form-section--hidden': section.hidden }">
          <h2 *ngIf="section.title" [ngClass]="{ 'col-12 col-6--md col-4--sm': section.isGrid }">{{ section.title }}</h2>
          <div
            *ngIf="section.body"
            class="form-section__body"
            [ngClass]="{ 'col-12 col-6--md col-4--sm': section.isGrid }"
            [internalInnerHtml]="section.body"
            [userEventSource]="userEventSource"
          ></div>

          <air-form-control
            *ngFor="let control of section.controls"
            (keydown)="onKeyDown($event)"
            (keyup)="onKeyUp($event)"
            (files)="setFiles($event)"
            (filesBusy)="setFilesBusy($event)"
            [control]="control"
            [group]="form"
            [formState]="formState"
            [showMandatory]="showMandatory"
            [userEventSource]="userEventSource"
            [ngClass]="control.containerClass ? control.containerClass : section.isGrid ? 'col-12 col-6--md col-4--sm' : null"
          ></air-form-control>
        </div>
      </ng-container>
    </div>

    <div *ngIf="enableAlternateReCaptcha" class="form-group--grecaptcha">
      <air-recaptcha-fallback #reCaptchaFallback></air-recaptcha-fallback>
    </div>
  </div>
  <ng-content></ng-content>
</form>
